import { render, staticRenderFns } from "./PlatformLanguage.vue?vue&type=template&id=1478155a&scoped=true"
import script from "./PlatformLanguage.vue?vue&type=script&lang=js"
export * from "./PlatformLanguage.vue?vue&type=script&lang=js"
import style0 from "./PlatformLanguage.vue?vue&type=style&index=0&id=1478155a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1478155a",
  null
  
)

export default component.exports